const oauthTypeEnum = Object.freeze({
  0: 'ApiIntegration_Type_Other',
  1: 'ApiIntegration_Type_PublicKey',
  2: 'ApiIntegration_Type_Secret',
  3: 'ApiIntegration_Type_MTLS'
})

export { oauthTypeEnum }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/OauthTypeEnum.js